module.exports = __webpack_public_path__ + "static/microphones_800.b621d271.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/photos/microphones_800.jpg
// module id = 617
// module chunks = 0